import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";

export default class SelectBox extends Component {
  static propTypes = {
    label: PropTypes.string,
    PickerComponent: PropTypes.func,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    disabled: false
  };

  render() {
    const { label, PickerComponent, className, disabled, ...rest } = this.props;
    return (
      <Wrapper>
        <PickerComponent {...rest} disabled={disabled}>
          <WrapperSelect className={className} disabled={disabled}>
            <Label>{label}</Label>
            <IconWrapper disabled={disabled}>
              <Icon name="arrow-down-white" width={12} />
            </IconWrapper>
          </WrapperSelect>
        </PickerComponent>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div``;

const WrapperSelect = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
`;
const Label = styled.div`
  padding: 0 4px;
  &:first-letter {
    text-transform: capitalize;
  }
`;
const IconWrapper = styled.div`
  /* background-color: ${props => props.theme.blueButton}; */
  background-color: ${props =>
    props.disabled ? "#ddd" : props.theme.blueButton};
  border-radius: 0 3px 3px 0;
  padding: 0 4px;
`;



// WEBPACK FOOTER //
// ./src/module-common/SelectBox.js